import { useState, type ReactNode } from "react";
import { photoUrl } from "../lib/photos";

/**
 * Eigen logo van de organisatie (Organisatie → Logo en huisstijl), op een wit vlak zodat ook een
 * donker logo in het donkere thema leesbaar is. Zonder logo, of als het niet laadt: `fallback`.
 * Met `icon` het vierkante pictogram (kleine plekken), anders het logo; zonder pictogram ook het logo.
 */
export function OrgLogo({
  org,
  className = "",
  fallback = null,
  icon = false,
}: {
  org: { name: string; reportLogoFileId: string | null; iconFileId?: string | null } | null | undefined;
  className?: string;
  fallback?: ReactNode;
  icon?: boolean;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const iconId = icon ? org?.iconFileId : null;
  const id = iconId || org?.reportLogoFileId;
  if (!org || !id || failed === id) return fallback;
  return (
    <span className={`org-logo ${iconId ? "is-icon" : ""} ${className}`}>
      <img src={photoUrl(id)} alt={`Logo ${org.name}`} onError={() => setFailed(id)} />
    </span>
  );
}
